import { OfferingInsuranceProductSearchResponse } from '@lio/api-types';
import { userQueryKey } from '@services/user/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchOfferingInsuranceProducts = (offeringId?: string) => {
  const client = useClient();

  const result = useQuery<OfferingInsuranceProductSearchResponse>({
    queryKey: [userQueryKey.getWithParams(offeringId ?? ''), 'insuranceProducts'],
    queryFn: () =>
      client.get(`offering/${offeringId}/insurance-product`).json<OfferingInsuranceProductSearchResponse>(),
    refetchOnWindowFocus: false,
    enabled: !!offeringId,
  });
  return { ...result, insuranceProducts: result.data?.items ?? [] };
};
